"use client"

import { useMemo } from "react"
import { Logger } from "@/lib/logger-client"
import { useUser } from "./use-user"

/**
 * Returns a Logger with user_id AND user_email when the user is logged in, so
 * client logs correlate with server logs (which carry both) in Datadog.
 *
 * @example
 * const logger = useLogger()
 * logger.info("Page visited", { pathname: "/dashboard" })
 */
export function useLogger() {
  const { user } = useUser()
  return useMemo(
    () =>
      user?.id
        ? Logger({ user_id: user.id, ...(user.email ? { user_email: user.email } : {}) })
        : Logger(),
    [user?.id, user?.email]
  )
}
